"use strict";

var BaseCollection = require('./baseCollection');
var Message = require('./message');

module.exports = BaseCollection.extend({
    type: 'messages',
    model: Message,
    comparator: 'created'
});


//////////////////
// WEBPACK FOOTER
// ./models/messages.js
// module id = 785
// module chunks = 2